<template>
  <div class="image-container" ref="imageContainer">
    <slot>
      <a-image
        v-if="$attrs.src && mounted"
        v-bind="$attrs"
        :preview="isPreview"
        @click="handleClick"
        :width="$attrs.width ? $attrs.width : getterWidth()"
        :height="$attrs.height ? $attrs.height : getterHeight()"
        :class="[{ scale: $attrs.scale !== undefined }, 'inherit-size']"
      />
    </slot>
  </div>
</template>

<script setup>
import { ref, reactive, toRefs, onMounted } from "vue";
const props = defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});
const handleClick = (e) => {
  if (props.isPreview) {
    e.stopPropagation();
  }
};
let imageContainer = ref(null);
const getterWidth = () => {
  return imageContainer.value.offsetWidth;
};
const getterHeight = () => {
  return imageContainer.value.offsetHeight;
};
let mounted = ref(false);
onMounted(() => {
  mounted.value = true;
  getterWidth();
  getterHeight();
});
</script>

<style lang="less" scoped>
.image-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  .inherit-size {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
